/**
 * Tools that are set to other mouse keys, while regular cornerstone tools are set to LMB
 */
export enum CornerstoneAdditionalTool {
  Pan = 'Pan',
  CustomZoomMouseWheel = 'CustomZoomMouseWheel',
  StackScrollMouseWheel = 'StackScrollMouseWheel',
  EmptyTool = 'EmptyTool',
}
